import { render } from "./MobilePricing.vue?vue&type=template&id=5220da36&scoped=true"
import script from "./MobilePricing.vue?vue&type=script&lang=js"
export * from "./MobilePricing.vue?vue&type=script&lang=js"

import "./MobilePricing.vue?vue&type=style&index=0&id=5220da36&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5220da36"]])

export default __exports__